import React from "react";

import Box from "../../../components/Box/Box";
import Flex from "../../../components/Box/Flex";
import Image from "../../../components/Image/Image";

interface Props {
  href: string;
}

const Logo: React.FC<React.PropsWithChildren<Props>> = () => {
  return (
    <Flex alignItems="center">
      <Box
        height={40}
        width={124}
        onClick={() => {
          window.scrollTo({ top: 0 });
          window.open("https://vndc.io/");
        }}
        // tests
        style={{
          cursor: "pointer",
        }}
      >
        <Image height={40} width={124} src="/images/logo.png" alt="icon" />
      </Box>
      <div
        style={{
          marginLeft: 10,
          borderRadius: 5,
          background: "rgba(204, 204, 204, 0.15)",
          padding: "4px 8px",
          color: "#AAA",
          fontSize: 14,
          fontWeight: 500,
          textTransform: "uppercase",
        }}
      >
        Beta
      </div>
    </Flex>
  );
};

export default React.memo(Logo);
